var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Undo(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "m5.833 5.508 1.855.701c.518.196.78.774.587 1.292a.998.998 0 0 1-1.289.583L3.342 6.707c-.4-.15-.66-.538-.65-.965l.094-3.694a.998.998 0 0 1 1.026-.973c.553.015.99.476.976 1.03l-.044 1.72.107-.085c3.404-2.383 8.089-1.564 10.465 1.83 2.376 3.393 1.542 8.075-1.861 10.459-3.404 2.383-8.089 1.564-10.465-1.829-.268-.457-.133-.875.407-1.252.54-.378.951-.344 1.234.103l.003-.002c1.742 2.489 5.178 3.089 7.674 1.341 2.496-1.747 3.107-5.181 1.364-7.67-1.742-2.488-5.178-3.088-7.674-1.34a1.56 1.56 0 0 0-.165.13Z" }) })));
}
export default Undo;
